module.exports = __webpack_public_path__ + "static/img/home_case_logoWall.c62c699.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_case_logoWall.webp
// module id = 9FFE
// module chunks = 34